import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "clock",
  "use": "clock-usage",
  "viewBox": "0 0 97.16 97.16",
  "content": "<symbol viewBox=\"0 0 97.16 97.16\" id=\"clock\">\r\n\t\t<path d=\"M48.58,0C21.793,0,0,21.793,0,48.58s21.793,48.58,48.58,48.58s48.58-21.793,48.58-48.58S75.367,0,48.58,0z M48.58,86.823\r\n\t\t\tc-21.087,0-38.244-17.155-38.244-38.243S27.493,10.337,48.58,10.337S86.824,27.492,86.824,48.58S69.667,86.823,48.58,86.823z\" />\r\n\t\t<path d=\"M73.898,47.08H52.066V20.83c0-2.209-1.791-4-4-4c-2.209,0-4,1.791-4,4v30.25c0,2.209,1.791,4,4,4h25.832\r\n\t\t\tc2.209,0,4-1.791,4-4S76.107,47.08,73.898,47.08z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/clock.svg
// module id = 122
// module chunks = 1